const getViewed = (store) => {
	return store.Session.viewed;
};

export default getViewed;
